import { availabilityModes } from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/constants'

import { allProducts, filterOptionsConfig } from './constants'

const isExcludedFilter = availabilityMode => {
  return [
    availabilityModes.nonExcludedProductTypes,
    availabilityModes.nonExcludedProductCategories,
    availabilityModes.nonExcludedProductTags,
  ].includes(availabilityMode)
}

export const getMenuItems = (returnReasonsFiltering, t) => {
  return filterOptionsConfig
    .filter(option => option.value === allProducts || returnReasonsFiltering?.includes(option.filteringType))
    .map(option => ({ label: t(option.label), value: option.value }))
}

export const isFilteringByProductTypes = availabilityMode => {
  return [availabilityModes.productTypes, availabilityModes.nonExcludedProductTypes].includes(availabilityMode)
}

export const isFilteringByProductCategories = availabilityMode => {
  return [availabilityModes.productCategories, availabilityModes.nonExcludedProductCategories].includes(
    availabilityMode
  )
}

export const isFilteringByProductTags = availabilityMode => {
  return [availabilityModes.productTags, availabilityModes.nonExcludedProductTags].includes(availabilityMode)
}

export const getProductTypesFilterLabel = availabilityMode => {
  return isExcludedFilter(availabilityMode) ? 'Tipos excluidos' : 'Tipos de producto'
}

export const getProductCategoriesFilterLabel = availabilityMode => {
  return isExcludedFilter(availabilityMode) ? 'Categorías excluidas' : 'Categorías de producto'
}

export const getProductTagsFilterLabel = availabilityMode => {
  return isExcludedFilter(availabilityMode) ? 'Tags excluidos' : 'Etiquetas de producto'
}

export const getProductTypeOptions = productTypes => {
  return productTypes?.map(productType => ({ label: productType.name, value: productType.name }))
}

export const getCategoryOptions = categories => {
  return categories?.map(category => ({ label: category.name, value: category.id }))
}
